import React from 'react';
import PropTypes from 'prop-types';
import { AdvancedImage, responsive } from '@cloudinary/react';

/**
 * Company Logo component that maintains aspect ratio within a square container
 * Provides a consistent UI for company logos across the application
 *
 * This component preserves all styling from the original implementation
 * while adding support for maintaining aspect ratio.
 */
const CompanyLogo = ({
  logoImage,
  width,
  height,
  className,
}) => {
  // Apply responsive plugin and set specific transformations if needed
  // Note: The logoImage should already have dpr set by parent component

  return (
    <div
      className={`pressrelease-logo-container press-release-title__company-logo-container__company-logo ${className || ''}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    >
      <AdvancedImage
        cldImg={logoImage}
        plugins={[responsive()]}
      />
    </div>
  );
};

CompanyLogo.propTypes = {
  // Using shape instead of object to be more specific
  logoImage: PropTypes.shape({}).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

CompanyLogo.defaultProps = {
  width: 90,
  height: 90,
  className: '',
};

export default CompanyLogo;
